import axios from "axios";

const baseURL = "https://demo.kapzar.com/api";
const axiosModificado = axios.create({
  baseURL: baseURL
})
export default axiosModificado;